// extracted by mini-css-extract-plugin
export default {"discountBadge":"_2p69O","discountIcon":"u2__y","xxl":"_1aMug","xl":"LdQl8","lg":"_221yy","md":"_3zOmu","sm":"_1tVem","xs":"_3UEly"};